var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "button",
        { staticClass: "btn btn-primary", on: { click: _vm.addMovimento } },
        [_vm._v("Adicionar movimento")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("div", { staticClass: "form-check" }, [
            _c("input", {
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "filtra-deletados" },
              on: { change: _vm.setDeletados }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "filtra-deletados" }
              },
              [
                _vm._v(
                  "\n                    Mostrar Apenas Deletados\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("v-table", {
            attrs: {
              column: _vm.colunas,
              data: _vm.dataComputed,
              actions: _vm.actionsTable
            },
            on: { show: _vm.show, delet: _vm.destroy, edit: _vm.recuperar }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "modal-estoque",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Selecione um Produto")]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          options: _vm.objProduto,
                          disabled: _vm.showHistorico
                        },
                        model: {
                          value: _vm.produto,
                          callback: function($$v) {
                            _vm.produto = $$v
                          },
                          expression: "produto"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showHistorico,
                        expression: "!showHistorico"
                      }
                    ],
                    staticClass: "row"
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Tipo Movimentação")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.movimentacao,
                              expression: "movimentacao"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.movimentacao = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Entrada / Saída")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "ENTRADA" } }, [
                            _vm._v("Entrada")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "SAIDA" } }, [
                            _vm._v("Saída")
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showHistorico,
                        expression: "!showHistorico"
                      }
                    ],
                    staticClass: "row"
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Quantidade")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quantidade,
                            expression: "quantidade"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.quantidade },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quantidade = $event.target.value
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showHistorico,
                        expression: "showHistorico"
                      }
                    ],
                    staticClass: "row"
                  },
                  [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table-bordered table-striped table-hover"
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.tableHistorico, function(item, i) {
                              return _c("tr", { key: i }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(item.created_at))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.movimentacao))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(item.produto.codigo) +
                                      " - " +
                                      _vm._s(item.produto.nome)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.quantidade))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.usuario.name))])
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v("Cancelar")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showHistorico,
                        expression: "!showHistorico"
                      }
                    ],
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.saveProduto }
                  },
                  [_vm._v("Salvar")]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Data")]),
        _vm._v(" "),
        _c("th", [_vm._v("Movimentação")]),
        _vm._v(" "),
        _c("th", [_vm._v("Produto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Quant.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Usuário")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-624b485c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624b485c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/produtos/AdmEstoque.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-624b485c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/produtos/AdmEstoque.vue
// module chunks = 2